import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("chizy_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && err.response.status === 401) {
      // Default seguro: cualquier 401 cierra la sesión, SALVO que el backend
      // indique explícitamente que es un token de migración inválido
      // (code === "migration_token_invalid"). Ese caso lo maneja la pantalla
      // de migración mostrando el error inline, sin desloguear.
      const code = err.response.data && err.response.data.detail && err.response.data.detail.code;
      if (code !== "migration_token_invalid") {
        localStorage.removeItem("chizy_token");
        localStorage.removeItem("chizy_user");
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(err);
  }
);

export default api;

export const downloadBlob = (data, filename) => {
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

const todayStr = () => new Date().toISOString().slice(0, 10);
export { todayStr };

const _locale = () => {
  try {
    const raw = localStorage.getItem("chizy_lang") || "es";
    return raw.startsWith("en") ? "en-US" : "es-MX";
  } catch {
    return "es-MX";
  }
};

export const fmtMXN = (n) =>
  new Intl.NumberFormat(_locale(), {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2,
  }).format(n || 0);

export const fmtNumber = (n) =>
  new Intl.NumberFormat(_locale(), { minimumFractionDigits: 0 }).format(n || 0);

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(_locale(), {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso;
  }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(_locale(), {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

export const daysFromNow = (iso) => {
  if (!iso) return null;
  const target = new Date(iso);
  const now = new Date();
  return Math.ceil((target - now) / (1000 * 60 * 60 * 24));
};
